import React, { FC } from "react";
import { RadioButton } from "designsystem";
import { useSupportResourceSet } from "hooks/resource-set";

export interface TopicProps {
  children: string;
  active: boolean;
  onChange?: () => void;
}

const Topic: FC<TopicProps> = ({ children, active, onChange }) => {
  const [translatedTitle] = useSupportResourceSet([
    `support.faq.topics.${children.toLowerCase()}`
  ]);
  return (
    <RadioButton
      key={`topic-${children}`}
      title={children}
      name={`topic-${children}`}
      active={active}
      onChange={onChange}
      marginTop="s"
    >
      {translatedTitle ?? children}
    </RadioButton>
  );
};

export default Topic;
